import { PropsWithChildren } from "react";
import classNames from "classnames";
import xIcon from "assets/icons/x-icon.svg";

type Props = {
	isOpen: boolean
	toggleModalOpen: () => void
}

function Modal({
	isOpen,
	toggleModalOpen,
	children,
}: PropsWithChildren<Props>) {
	return (
		<div className={ classNames("fixed top-0 left-0 z-20" ,{ "hidden": !isOpen }, { "block": isOpen }) }>
			<div className="absolute top-0 left-0 bg-black opacity-50 w-screen h-screen" onClick={ () => toggleModalOpen() }></div>
			<div className="fixed top-[50%] w-[80vw] sm:w-auto left-[50%] transform translate-x-[-50%] translate-y-[-50%] p-10 sm:p-16 bg-white rounded-2xl">
				<img
					src={ xIcon }
					alt="X"
					className="absolute top-[24px] right-[24px] cursor-pointer"
					onClick={ () => toggleModalOpen() }
				/>
				{ children }
			</div>
		</div>
	);
}

export default Modal;